export const userRoles = {
  1: `Validator`,
  2: `Admin`,
  3: `Provider`,
  4: `Recovery`,
  5: `Nacional`,
  Validator: `Validator`,
  Admin: `Admin`,
  Provider: `Provider`,
  Recovery: `Recovery`,
  ValidatorNacional: `ValidatorNacional`,
}

export const userRolesInSpanish = {
  1: `Evaluador`,
  2: `Administrador`,
  3: `Proveedor de Servicio`,
  Validator: `Evaluador`,
  Admin: `Administrador`,
  Provider: `Proveedor de Servicio`,
  ValidatorNacional: `Evaluador Nacional`,
}

export const promotionKind = {
  1: `Turista Nacional`,
  2: `Turista Internacional`,
  3: `Ambos`,
  Nacional: `Turista Nacional`,
  Internacional: `Turista Internacional`,
  Ambas: `Ambos`,
}

export const experienceStatus = {
  1: {
    label: `Aprobada`,
    className: `approved`,
  },
  2: {
    label: `Rechazada`,
    className: `rejected`,
  },
  3: {
    label: `En Validación`,
    className: `checking`,
  },
  4: {
    label: `En Proceso`,
    className: `edition`,
  },
  5: {
    label: `Pausada`,
    className: `paused`,
  },
  6: {
    label: `Desactivada`,
    className: `nonactive`,
  },
  7: {
    label: `En Edición`,
    className: `upgrading`,
  },
  8: {
    label: `En Revalidación`,
    className: `updagradechecking`,
  },
  9: {
    label: `Rechazo de Mejoras`,
    className: `rejected`,
  },
  10: {
    label: `Preaprobada`,
    className: `approved`,
  },
  11: {
    label: `Solicitud de eliminación`,
    className: `rejected`,
  }
}
 
export const actionsByStatus = {
  // Aprobada
  1: [`desactivate`, `pause`, `upgrade`,`edit`,`delete`],
  // Rechazada
  2: [`edit`],
  // En Revisión
  3: [`validate`, `derivar`,`edit`],
  // En Edición
  4: [`edit`,`delete`],
  // Pausada
  5: [`play`, `edit`, `desactivate`,`delete`],
  // Desactivada
  6: [`activate`, `watch`, `delete`,`edit`],
  // En Mejora
  7: [`upgrade`, `desactivate`,`edit`],
  // En Revisión de Mejoras
  8: [`validate`, `desactivate`, `deleteUpgrade`,`edit`],
  // Rechazo de Mejoras
  9: [`upgrade`, `desactivate`, `deleteUpgrade`,`edit`],
  // Pre Aprobada
  10: [`validate`, `edit`],
  // Solicitud de eliminación
  11: [`play`, `delete`,`edit`]
}

export const experienceActionsByRole = {
  [userRoles.Admin]: [`play`,`desactivate`, `activate`, `derivar`, `delete`,`edit`],
  [userRoles.Validator]: [`play`,`validate`, `desactivate`, `activate`, `derivar`,`edit`],
  [userRoles.Provider]: [
    `upgrade`,
    `pause`,
    `play`,
    //`desactivate`,
    `edit`,
    `delete`,
    `watch`,
    `deleteUpgrade`,
  ],
  [userRoles.ValidatorNacional]: [`validate`,`edit`],
}

export const validPublishedStatuses = [1, 7, 8, 9]

export const onReviewStatuses = [3, 8]

export const langNameByAbrv = {
  'pt-br': `Portugués, Brasil`,
  it: `Italiano`,
  fr: `Francés`,
  es: `Español`,
  en: `Inglés`,
  de: `Alemán`,
}

export default {
  userRoles,
  userRolesInSpanish,
  langNameByAbrv,
  promotionKind,
  experienceStatus,
  actionsByStatus,
  experienceActionsByRole,
  validPublishedStatuses,
  onReviewStatuses,
}
